import { mergeTwClasses } from '@utils/merge-tw-classes/merge-tw-classes';

import { AccordionListProps } from './accordion.type';

export const AccordionList = ({ children, className, ...props }: AccordionListProps) => (
  <div
    className={mergeTwClasses(
      'rounded-lg *:rounded-none [&>*:first-child]:rounded-t-lg [&>*:last-child]:rounded-b-lg [&>*:not(:first-child)]:border-t-0',
      className
    )}
    {...props}>
    {children}
  </div>
);
